module.exports = __webpack_public_path__ + "static/media/img_10.41ba973d.jpg";